module.exports = __webpack_public_path__ + "static/media/visitas-tui-c.01dda393.png";